import { Outlet } from 'react-router-dom';

import { Filtering, Pagination, QStack, Sorting } from '@qualio/ui-components';

import { useContext, useEffect } from 'react';
import { useFilterDefinitions } from '../../hooks/UseFilterDefinitions';
import { usePersistanceKey } from '../../hooks/usePersistanceKey';
import { SelectionWrapper } from '../../SelectionWrapper';
import { WorkspaceTabsContext } from '../../WorkspaceTabsContext';
import { WorkspaceTabs } from '../../WorkspaceV2';
import { AllDocumentsTable } from './AllDocumentsTable';

export const AllDocumentsTab = () => {
  const { Provider: PaginationProvider } = Pagination.useLimitOffset();
  const { setCurrentTab } = useContext(WorkspaceTabsContext);
  useEffect(() => {
    setCurrentTab(WorkspaceTabs.ALL_DOCUMENTS);
  }, [setCurrentTab]);

  const persistanceKey = usePersistanceKey();
  const filterDefinitions = useFilterDefinitions(WorkspaceTabs.ALL_DOCUMENTS);

  return (
    <QStack direction="column">
      <PaginationProvider>
        <Filtering.FilterProvider
          searchTermKey="query"
          definitions={filterDefinitions}
          persistanceKey={persistanceKey}
        >
          <Sorting.DefaultSortingProvider>
            <SelectionWrapper>
              <AllDocumentsTable />
            </SelectionWrapper>
          </Sorting.DefaultSortingProvider>
        </Filtering.FilterProvider>
      </PaginationProvider>
      <Outlet />
    </QStack>
  );
};
